import React, { useEffect, useState } from 'react';
import { getFiles } from '../../../hooks/api-methods/get-upload';
import { deleteFile } from '../../../hooks/api-methods/delete-upload';
import Loader from '../../../components/Loader/Loader';
import { Trash2 } from 'lucide-react';
import ConfirmModal from '../../../components/PopUps/ConfirmModal';

interface FileItem {
  name: string;
  url: string;
}

const LogoView: React.FC = () => {
  const [files, setFiles] = useState<FileItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const [showModal, setShowModal] = useState(false);
  const [selectedFile, setSelectedFile] = useState<FileItem | null>(null);

  async function fetchFiles() {
    try {
      const result = await getFiles('logo'); // Containernaam
      setFiles(result);
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError('Er is een onbekende fout opgetreden.');
      }
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchFiles();
  }, []);

  function confirmDelete(file: FileItem) {
    setSelectedFile(file);
    setShowModal(true);
  }

  // Confirm deletion
  async function handleConfirmDelete() {
    if (!selectedFile) return;
    try {
      setLoading(true);
      await deleteFile('logo', selectedFile.name);
      await fetchFiles();
    } catch (error) {
      console.error(error);
      alert('Verwijderen mislukt.');
    } finally {
      setShowModal(false);
      setSelectedFile(null);
      setLoading(false);
    }
  }

  if (loading) return <Loader />;
  if (error) return <p className="flex-row-align justify-center w-100 vh-75">{error}</p>;
  if (files.length === 0) return <p className="w-100 vh-75">Geen bestanden gevonden.</p>;

  return (
    <div className="ptb-2">
      <div className="flex-row">
        {files.map((file) => (
          <div className="thubnail-big relative" key={file.url}>
            <img
              className="w-100 h-100"
              src={file.url.trim()}
              alt={file.name}
              onError={(e) => {
                (e.currentTarget as HTMLImageElement).src =
                  'https://via.placeholder.com/150?text=Afbeelding+niet+beschikbaar';
              }}
            />
            <button onClick={() => confirmDelete(file)} className="button-delete">
              <Trash2 />
            </button>
          </div>
        ))}
      </div>
      <ConfirmModal
        isOpen={showModal}
        title="Bestand verwijderen"
        message={`Weet je zeker dat je '${selectedFile?.name}' wilt verwijderen?`}
        onConfirm={handleConfirmDelete}
        onCancel={() => setShowModal(false)}
      />
    </div>
  );
};

export default LogoView;
